import {
	EVerificationTypes,
	ICreateVerification,
	ISource,
	TCreateSourceRequest,
	TSourceList,
	TUpdateSourceRequest,
} from 'entities/Source';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings';
import { getCookie } from 'shared/utils/getCookie';

export const sourceApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getSource: builder.query<ISource, string>({
				query: (uuid) => ({
					url: `sources/${uuid}/`,
				}),
			}),
			getSourceList: builder.query<TSourceList, string>({
				query: (params) => ({
					url: `sources/${params ? '?' : ''}${params}`,
				}),
			}),
			addSource: builder.mutation<ISource, Partial<TCreateSourceRequest>>({
				query(body) {
					return {
						url: `sources/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
						body,
					};
				},
			}),
			updateSource: builder.mutation<ISource, Partial<TUpdateSourceRequest>>({
				query({ uuid, ...body }) {
					return {
						url: `sources/${uuid}/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'PUT',
						body,
					};
				},
			}),
			deleteSource: builder.mutation<null, string>({
				query(uuid) {
					return {
						url: `sources/${uuid}/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'DELETE',
					};
				},
			}),
			addVerification: builder.mutation<null, { body: ICreateVerification; type?: EVerificationTypes }>({
				query({ body, type }) {
					return {
						url: `sources/${body.source_pk}/verification/${type ? type + '/' : ''}`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'POST',
						body,
					};
				},
			}),
			deleteImage: builder.mutation<null, string>({
				query(uuid) {
					return {
						url: `arbitrage_screenshots/${uuid}/`,
						headers: { 'X-Csrftoken': getCookie('csrftoken') },
						method: 'DELETE',
					};
				},
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.SOURCES_LIST, EApiTags.SINGLE_SOURCE, EApiTags.ADSPACES_LIST],
		endpoints: {
			getSource: {
				providesTags: [EApiTags.SINGLE_SOURCE],
			},
			getSourceList: {
				providesTags: [EApiTags.SOURCES_LIST],
			},
			addSource: {
				invalidatesTags: [EApiTags.SOURCES_LIST, EApiTags.ADSPACES_LIST],
			},
			updateSource: {
				invalidatesTags: [EApiTags.SOURCES_LIST, EApiTags.SINGLE_SOURCE],
			},
			deleteSource: {
				invalidatesTags: [EApiTags.SOURCES_LIST],
			},
			addVerification: {
				invalidatesTags: [EApiTags.SOURCES_LIST, EApiTags.SINGLE_SOURCE],
			},
		},
	});

export const {
	useGetSourceQuery,
	useGetSourceListQuery,
	useAddSourceMutation,
	useUpdateSourceMutation,
	useDeleteSourceMutation,
	useAddVerificationMutation,
	useDeleteImageMutation,
} = sourceApi;
